import { render, staticRenderFns } from "./Laudos.vue?vue&type=template&id=68548504&lang=pug"
import script from "./Laudos.vue?vue&type=script&lang=js"
export * from "./Laudos.vue?vue&type=script&lang=js"
import style0 from "./Laudos.vue?vue&type=style&index=0&id=68548504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports